import { computed } from 'vue'
import { CSS_CLASSES } from '../constants/multiple-select-button-constants.js'

/**
 * Styling and CSS classes for Multiple Select Button component
 * Giữ nguyên logic class từ file gốc
 */
export function useMultipleSelectButtonStyles(props, componentState) {
  
  // Container classes - giữ nguyên logic từ template gốc
  const containerClasses = computed(() => [
    CSS_CLASSES.MULTIPLE_SELECT_BUTTON,
    CSS_CLASSES.FLEX_CENTER,
    componentState.shouldShowParentBorder.value ? CSS_CLASSES.BORDER_PARENT : '',
  ])
  
  // Menu wrapper classes
  const menuWrapperClasses = computed(() => [
    CSS_CLASSES.WIDGET_MORE_CONTAINER,
    CSS_CLASSES.WIDGET_BTN,
    props.type
  ])
  
  // Menu wrapper root class
  const menuWrapperRootClass = computed(() => CSS_CLASSES.WIDGET_ROOT_CLASS)
  
  // Button classes - giữ nguyên logic từ template gốc
  const buttonClasses = computed(() => [
    CSS_CLASSES.BTN,
    CSS_CLASSES.FLEX_ROW,
    CSS_CLASSES.PRIMARY_BUTTON,
    props.type,
    props.classCustom,
    componentState.shouldShowBorder.value ? '' : CSS_CLASSES.BORDER_NONE
  ])
  
  // Option item classes
  const optionItemClasses = computed(() => CSS_CLASSES.OPTION_ITEM)
  
  // Checkbox cell classes
  const checkboxCellClasses = computed(() => CSS_CLASSES.CELL_CHECKBOX)
  
  // Icon classes for checkbox
  const checkboxIconClasses = computed(() => CSS_CLASSES.ICON)
  
  // Dynamic icon classes based on selection state
  const getItemIconClasses = (item) => {
    const { cacheSelected, effectiveValueField } = componentState
    const isSelected = cacheSelected.value.has(item[effectiveValueField.value])
    return [
      CSS_CLASSES.ICON,
      isSelected ? CSS_CLASSES.CHECKED : ''
    ]
  }
  
  // Show/hide conditions
  const showData = computed(() => componentState.hasData.value)
  
  return {
    // Container
    containerClasses,
    
    // Menu wrapper
    menuWrapperClasses,
    menuWrapperRootClass,
    
    // Button
    buttonClasses,
    
    // Option items
    optionItemClasses,
    checkboxCellClasses,
    checkboxIconClasses,
    
    // Dynamic classes
    getItemIconClasses,
    
    // Show/hide
    showData
  }
}
